import { connect } from 'react-redux';
import { onClickButtonUpgradeMyPlan } from './events/onClick';
import { IButtonLargeDispatchProps } from '../../components/ButtonLarge/types';
import { SharedDrivesMSBlocker } from '../../components/SharedDrivesMSBlocker/SharedDrivesMSBlocker';

const mapDispatchToProps = (
    dispatch: any
): IButtonLargeDispatchProps => {
    return {
        onClick: () => dispatch(onClickButtonUpgradeMyPlan())
    }
};

export const SharedDrivesMSBlockerHOC = connect(
    null,
    mapDispatchToProps
)(SharedDrivesMSBlocker);

SharedDrivesMSBlockerHOC.displayName = 'SharedDrivesMSBlockerHOC';
